export interface ExemptionData {
  redemptionValue: string;
  desiredRedemptionValue: string;
  redemptionValueGap: string;
  exemptionReason: string;
  repurchaseAgreement: boolean | null;
}

export const DEFAULT_EXEMPTION: ExemptionData = {
  redemptionValue: '',
  desiredRedemptionValue: '',
  redemptionValueGap: '',
  exemptionReason: '',
  repurchaseAgreement: null
};

export type DerogationRequest = {
  changeDate?: Date;
  comments?: string;
  description: string;
  initialValue: number;
  purchaseCommit: boolean | null;
  requestedValue: number;
  status: string;
  treatedDate?: Date;
};
